import {useEffect} from "react"
import {useAppContext} from "./useAppContext";
import {addRecentlyViewed} from "../utils/helpers";

/**
 * This hook adds the current product to the recently viewed list.
 * @constructor useAddToRecentlyViewed
 */
export const useAddToRecentlyViewed = () => {
    const {productId} = useAppContext();

    useEffect(() => {
        addRecentlyViewed(productId);
    }, [productId]);
}